<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-07-26 10:50:42
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-11 12:22:14
 * @FilePath: /chaoyongtuan/src/views/shopManage/tobeClaimed/list/components/audit.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<el-dialog :title="title" :visible.sync="visible" width="500px" @close="handleClose">
			<div class="yx-color-text-primary mb-20 fz-16">
				<span class="ml-10">{{ contnet }}</span>
			</div>

			<span slot="footer">
				<el-button @click="visible = false">取 消</el-button>
				<el-button type="primary" @click="confirm">确认审核</el-button>
			</span>
		</el-dialog>
		<loading-dialog ref="loadingDialogRef" @close="handleLoadingClose" message="处理中"></loading-dialog>
		<audit-result-dialog ref="auditResultDialogRef" :auditResult="auditResult"></audit-result-dialog>
	</div>
</template>
<script>
import { ksActivityBatchAudit, dyActivityAuditBatch } from '@/api/secondColonelManage';
import { zsRoleType } from '@/utils/dataMap';
import { mapGetters } from 'vuex';
import LoadingDialog from '@/components/ui/loadingDialog';
import AuditResultDialog from './auditResultDialog';
export default {
	components: {
		LoadingDialog,
		AuditResultDialog,
	},
	data() {
		return {
			visible: false,
			title: '提示',
			params: [],
			contnet: '',
			auditResult: {
				total: 0,
				success: 0,
				fail: 0,
			},
		};
	},
	computed: {
		...mapGetters(['isAllDataView']),
		zsName() {
			return zsRoleType.name;
		},
		authorityId() {
			return this.$route.query.authority_id;
		},
		platformId() {
			return this.$route.query.platform_id;
		},
	},
	methods: {
		show(params, contnet) {
			this.params = params;
			this.contnet = contnet;
			this.visible = true;
		},
		auditDataUtil() {
			const { platformId } = this;
			let paramsDy = {};
			let paramsKs = {};
			//批量操作
			const apiMap = {
				1: dyActivityAuditBatch,
				2: ksActivityBatchAudit,
			};
			paramsDy = { productInfos: [], auditStatus: 1 };
			paramsKs = { productInfos: [], auditStatus: 3 };
			this.params.forEach(item => {
				paramsDy.productInfos.push({
					productId: item.product_id,
					thirdProductId: item.third_product_id,
				});
				paramsKs.productInfos.push({
					productId: item.product_id,
					thirdProductId: item.third_product_id,
				});
			});
			let paramsMap = {
				1: paramsDy,
				2: paramsKs,
			};

			return apiMap[platformId](paramsMap[platformId]);
		},

		async confirm() {
			try {
				this.visible = false;
				this.$refs.loadingDialogRef.show();
				const { code, data } = await this.auditDataUtil();
				if (code !== 0) return this.$refs.loadingDialogRef.pureClose();
				const { successNum, failNum } = data;
				this.auditResult = {
					total: this.params.length,
					success: successNum,
					fail: failNum,
				};
				this.$refs.loadingDialogRef.close();
				this.$emit('refreshList');
			} catch (error) {
				this.$refs.loadingDialogRef.pureClose();
			}
		},
		handleClose() {},
		handleLoadingClose() {
			this.$refs.auditResultDialogRef.show();
		},
	},
};
</script>
<style lang="less" scoped>
.warn_img {
	width: 16px;
	height: 16px;
	margin-bottom: 2px;
	margin-right: 6px;
}
</style>
